export enum FunctionalAnalysisObjectTypeEnum {
  Tba = 1,
  UncontrolledTransaction,
  Pba,
 }
